<template>
  <div class="c-folder-layer__item d-flex align-items-center mt-2">
    <div class="c-folder-layer__item--preview mr-2">
      <div class="a-shape-layer">
        <b-icon
          icon="square"
          class="d-block"
        />
      </div>
    </div>
    <div
      ref="tooltip"
      class="layer--item__text"
    >
      <b-tooltip
        :show.sync="isTooltipShown"
        :target="() => $refs.tooltip"
        triggers="hover"
        boundary="viewport"
        noninteractive
        :disabled="isNotTruncated(name)"
      >
        {{ name }}
      </b-tooltip>
      <EditableTextElement
        :default-value="name"
        :render-value="truncateFieldName"
      />
    </div>
  </div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";
import EditableTextElement from "@frontend/components/common/atoms/EditableTextElement.vue";
import {ApplyStrategy} from "@frontend/services/api/psd-layers";
import layerMixin from './mixin';

export default {
  name: "ShapeLayer",
  components: {
    EditableTextElement,
  },
  mixins: [layerMixin],
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {

  },
}
</script>
